import { fetchHelper } from "../utils"

export const getActiveLearners = async () => {
    return fetchHelper({
        url: 'learners/actives',
        method: 'GET',
    }) as Promise<any[]>
}